import _ from 'lodash';
import utf8 from 'utf8';
import base64 from 'base-64';
export var encodeBase64 = function encodeBase64(str) {
  var bytes = utf8.encode(str);
  return base64.encode(bytes);
};
export var decodeBase64 = function decodeBase64(base64Str) {
  var bytes = base64.decode(base64Str);
  return utf8.decode(bytes);
};